import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/sliders'

class SliderDataService extends RestApiDataService {

}

export default new SliderDataService(BASE_ENTITY_URL)
